export function formatSalary(value: number, currency: string) {
  return `${currency.toUpperCase()} ${Intl.NumberFormat().format(value)}`;
}
